<template>
  <div class="flex items-center justify-between py-2 w-full">
    <dropdown class="mt-1 w-full" placement="bottom-end">
      <template #default>
        <div class="group flex items-center cursor-pointer select-none w-full">
          <div v-if="label" class="border px-4 py-3 -mt-1 flex items-center justify-between w-full">
            <span>Download Documents</span>
            <icon class="w-4 h-4 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="cheveron-down" />
          </div>
          <icon v-else class="w-4 h-4 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="download" />
        </div>
      </template>
      <template #dropdown>
        <div class="mt-2 py-2 text-sm bg-white  shadow-xl">
          <a class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="bulk('drawing')" target="_blank">Drawings</a>
          <a class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="bulk('bom')" target="_blank">BOM PDF</a>
          <a v-if="quote" class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="bulk('quote')" target="_blank">Quote PDF</a>
          <a v-if="csv" class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="downloadCSV" target="_blank" download>Quote CSV</a>
          <a v-if="csv" class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="downloadExcel" target="_blank" download>Quote Excel</a>
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
    Icon,
  },
  props: {
    project: Number,
    runs : Array,
    label: {
      type   : Boolean,
      default: false,
    },
    quote: {
      type   : Boolean,
      default: true,
    },
    csv  : {
      type   : Boolean,
      default: true,
    },
  },
  computed: {
    runsParams () {
      return this.runs.map(function(el, idx) {
        return 'runs[' + idx + ']=' + el
      }).join('&')
    },
    downloadCSV() {
      return `/projects/bulk/${this.project}/csv?${this.runsParams}`
    },
    downloadExcel() {
      return `/projects/bulk/${this.project}/xlsx?${this.runsParams}`
    },
  },
  methods: {
    bulk(route) {
      return `/bulk/${this.project}/${route}?${this.runsParams}`
    },
  },
}
</script>
